(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["accelerated-checkout"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('buy-it-now-button')) {
    class BuyItNowButton extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('button');
        this.button?.addEventListener('click', this.#onClick);
      }

      disconnectedCallback() {
        this.button?.removeEventListener('click', this.#onClick);
      }

      #onClick = () => {
        const form = this.closest('form');
        if (!form) return;
        const variantId = form.querySelector('[name="id"]')?.value;
        if (!variantId) return;
        const quantityInput = form.querySelector('[name="quantity"]');
        const quantity = Math.max(1, parseInt(quantityInput?.value, 10) || 1);
        const root = window.Shopify?.routes?.root || '/';
        this.button.setAttribute('aria-busy', 'true');
        this.button.disabled = true;
        window.location.href = `${root}cart/${variantId}:${quantity}`;
      };
    }
    customElements.define('buy-it-now-button', BuyItNowButton);
  }
  } catch(e) { console.error(e); }
})();

})();
